import { useState } from "react";

import { Button, Toastr, Typography } from "neetoui";
import PropTypes from "prop-types";
import { useTranslation, Trans } from "react-i18next";

import { DEFAULT_EMAIL, DEFAULT_PASSWORD } from "./constants";
import SignInForm from "./Form";

const SignIn = ({ handleSubmit }) => {
  const [isSubmitting, setIsSubmitting] = useState(null);
  const { t } = useTranslation();

  const redirectAfterSuccessfulLogin = redirectTo => {
    window.location.pathname = redirectTo || "/";
  };

  const handleFormSubmit = async formValues => {
    try {
      const response = await handleSubmit({ user: formValues });
      Toastr.success(t("neetoMolecules.login.success"));
      redirectAfterSuccessfulLogin(response.redirectTo);
    } catch {
      /* empty */
    }
  };

  const loginAsOliver = async () => {
    setIsSubmitting(true);
    await handleFormSubmit({
      email: DEFAULT_EMAIL,
      password: DEFAULT_PASSWORD,
    });
    setIsSubmitting(false);
  };

  return (
    <div className="flex h-dvh w-full justify-center">
      <div className="neeto-ui-bg-white neeto-ui-rounded-lg neeto-ui-shadow-sm flex w-full max-w-lg flex-col gap-y-6 self-center p-8 sm:min-w-max sm:p-10">
        <Typography style="h3" weight="medium">
          <Trans
            components={{ bold: <b /> }}
            i18nKey="neetoMolecules.login.toOrganizationAccount"
            values={{ organizationName: globalProps.organization.name }}
          />
        </Typography>
        <Button
          fullWidth
          disabled={isSubmitting}
          label={t("neetoMolecules.login.loginAsOliver")}
          loading={isSubmitting}
          size="large"
          style="primary"
          onClick={loginAsOliver}
        />
        <Typography className="text-center" style="body1" weight="semibold">
          {t("neetoMolecules.common.or").toLocaleUpperCase()}
        </Typography>
        <SignInForm {...{ handleFormSubmit }} />
      </div>
    </div>
  );
};

SignIn.propTypes = {
  /**
   * The function that is triggered when login button is clicked.
   */
  handleSubmit: PropTypes.func,
};

export default SignIn;
